module.exports = __webpack_public_path__ + "img/02.0d1ea489.png";